import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import { toRoman } from 'helpers'

import { canManageBuilding } from 'helpers/accounts'

import { MODERNIZATION_OVERLAY_TITLE } from 'components/ModernizationOverlay/constants.jsx'

import BaseBonusInfoTable from 'components/BaseBonusInfoTable/BaseBonusInfoTable.jsx'
import Warning from 'components/Warning/Warning.jsx'
import IndustrialResource from 'components/IndustrialResource/IndustrialResource.jsx'

import {
    COMMAND_CENTER_LEVEL_HEADER,
    REQUIRED_BUILDINGS_LEVEL_SUMM_HEADER,
    UPGRADE_COMMAND_CENTER_COST_HEADER,
    PERMISSIONS_REQUIRED_MESSAGE,
    UPGRADE_COMMAND_CENTER_DECRIPTION,
    MAX_COMMAND_CENTER_LEVEL_MESSAGE,
    COMMAND_CENTER_UPGRADE_TABLE_TITLE,
} from './constants.jsx'

import {
    MAX_BUILDING_LEVEL,
} from 'constants'

import styles from './UpgradeEffectContent.scss'

export const UpgradeEffectContent = ({
    upgradeCosts,
    requiredLevels,
    currentLevel,
    hasPermission,
}) => {
    const columns = [{
        title: COMMAND_CENTER_LEVEL_HEADER,
        dataIndex: 'level',
        align: 'left',
    }, {
        title: REQUIRED_BUILDINGS_LEVEL_SUMM_HEADER,
        dataIndex: 'buildingsLevelSum',
    }, {
        title: UPGRADE_COMMAND_CENTER_COST_HEADER,
        dataIndex: 'upgradeCost',
        render: (value) => {
            return (
                <IndustrialResource
                    value={value}
                    small
                />
            )
        },
    }]

    const dataSource = upgradeCosts.map((upgradeCost, index) => {
        return {
            level: index + 1,
            buildingsLevelSum: requiredLevels[index],
            upgradeCost,
        }
    })

    const isMaxLevelReached = (currentLevel === MAX_BUILDING_LEVEL)

    return (
        <div className={styles.base}>
            <div className={styles.header}>
                <h2 className={styles.title}>
                    <span className={styles.titleText}>
                        {MODERNIZATION_OVERLAY_TITLE}
                    </span>
                </h2>
                {!hasPermission && !isMaxLevelReached && (
                    <div className={styles.warning}>
                        <Warning type='warning'>{PERMISSIONS_REQUIRED_MESSAGE}</Warning>
                    </div>
                )}
                <div className={styles.description}>
                    {isMaxLevelReached ? (
                        MAX_COMMAND_CENTER_LEVEL_MESSAGE
                    ) : (
                        UPGRADE_COMMAND_CENTER_DECRIPTION(
                            <span className={styles.nextLevel}>{toRoman(currentLevel + 1)}</span>
                        )
                    )}
                </div>
            </div>
            <div className={styles.content}>
                <div className={styles.bonusHolder}>
                    <BaseBonusInfoTable
                        classNames={{
                            title: styles.tableTitle,
                        }}
                        title={COMMAND_CENTER_UPGRADE_TABLE_TITLE}
                        columns={columns}
                        selectedRow={currentLevel - 1}
                        dataSource={dataSource}
                    />
                </div>
            </div>
        </div>
    )
}

UpgradeEffectContent.propTypes = {
    upgradeCosts: PropTypes.arrayOf(PropTypes.number).isRequired,
    requiredLevels: PropTypes.arrayOf(PropTypes.number).isRequired,
    currentLevel: PropTypes.number.isRequired,
    hasPermission: PropTypes.bool.isRequired,
}

export const mapStateToProps = (state) => {
    const currentLevel = state.stronghold.level
    const requiredLevels = [0, ...state.settings.command_center.required_total_stronghold_level_to_upgrade]
    const upgradeCosts = state.settings.command_center.costs
    const hasPermission = canManageBuilding(state.account)
    return {
        upgradeCosts,
        requiredLevels,
        hasPermission,
        currentLevel,
    }
}

export default connect(
    mapStateToProps
)(UpgradeEffectContent)



// WEBPACK FOOTER //
// ./containers/CommandCenterCard/components/UpgradeEffectContent/UpgradeEffectContent.jsx